import { render, staticRenderFns } from "./DynamicIcon.vue?vue&type=template&id=cb24f46e&"
import script from "./DynamicIcon.vue?vue&type=script&lang=ts&"
export * from "./DynamicIcon.vue?vue&type=script&lang=ts&"
import style0 from "./DynamicIcon.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('cb24f46e', component.options)
    } else {
      api.reload('cb24f46e', component.options)
    }
    module.hot.accept("./DynamicIcon.vue?vue&type=template&id=cb24f46e&", function () {
      api.rerender('cb24f46e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/components/icons/DynamicIcon.vue"
export default component.exports